/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { settingsUserConfig } from '../../config/settings.config';
export interface ISettingsUserPluginMethods extends IPluginMethodMap {
  getSettingsUserSync(args?: any): any;
}

export class SettingsUserPlugin implements IAgentPlugin {
  readonly methods: ISettingsUserPluginMethods;

  constructor() {
    this.methods = {
      getSettingsUserSync: this.getSettingsUserSync.bind(this),
    };
  }

  getSettingsUserSync(args?: any) {
    return {
      settings: settingsUserConfig,
    };
  }
}
